export interface Contract {
  id: number,
  prestatorId: number,
  clientId: number,
  date: string,
  status: number
}

export const initialContractsState = {
  contracts: [],
};

export interface IContractsState {
  contracts: Contract[],
}
